import script from "./RightArea.vue?vue&type=script&setup=true&lang=js"
export * from "./RightArea.vue?vue&type=script&setup=true&lang=js"

import "./RightArea.vue?vue&type=style&index=0&id=acf8a2f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acf8a2f2"]])

export default __exports__